import React, { useState, useEffect, useContext, useRef } from "react";
import "../assets/css/Modal.css";
import { Form, Modal, Tab, Tabs } from "react-bootstrap";
import "../assets/css/Style.css";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import "../styles/utility.css";
import "../styles/cardResponsive.css"; // Card responsive styles
import { getApiService } from "../services/ApiService";
import { Spinner } from "react-bootstrap";
import { GetPayLoad } from "../services/PayLoadStorage";
import DateRangePickerr from "../components/dateRangePickerr.jsx";
import { toast } from "react-toastify";
import { LanguageContext } from "../contexts/LanguageContext";
import { useReactToPrint } from "react-to-print";
import Cookies from "js-cookie";
import { getCookieOptions } from "../utils/cookieUtils";
import BillingPreference from "./billingPreference.jsx";
import { useNavigate } from 'react-router-dom';
import Billinghistory from "./billinghistory.jsx";
import PaymentHistory from "./PaymentHistory.jsx";
import AutoPayModal from "./AutoPay.jsx"
import Schedulepayment from "./schedulepayment.jsx";
import Paymentauth from "./paymentAuth.jsx";
import { handleFiservLogin } from "../services/FiservLoginService.jsx"; 

const Card = ({
  image,
  description,
  heading,
  subHeading,
  sendDataToBilling,
  caseInfo,
}) => {

  const navigate = useNavigate();

  const [modalText, setModalText] = useState();
  const [activeKey, setActiveKey] = useState("tab1");
  const [paymentAuthorizations, setpaymentAuthorizations] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [allPaymentAuth, setAllPaymentAuth] = useState([]);
  const [activeAccounts, setActiveAccounts] = useState([]);
  const [billingPreference, setBillingPreference] = useState([]);
  const [isActiveLoading, setActiveLoading] = useState(true);
  const [downloadFormat, setDownloadFormat] = useState("pdf");
  const Payload = GetPayLoad("PayLoad");

  const [address, setAddress] = useState([]);
  const [eMail, setEmail] = useState([]);
  const [isPrefLoading, setPrefLoading] = useState(true);
  const [currentBilling, setCurrentBilling] = useState([]);
  const [showSchedulePaymentModal, setShowSchedulePaymentModal] = useState(false);
  const [billingPrefErrorFlag, setBillingPrefErrorFlag] = useState(false);
  
  
  const [paymentAuthErrorFlag, setPaymentAuthErrorFlag] = useState(false);
  const contentRef = useRef();
  const reactToPrintFn = useReactToPrint({ contentRef });

  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const headers = {
    "X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
    "X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
    "X-Hps-Region": Payload?.region,
    "X-Hps-Carrier": Payload?.owning_carrier,
  };

  const { pageContent } = useContext(LanguageContext);
  const [billingContent, setBillingContent] = useState([]);
  const [genericContent, setGenericContent] = useState([]);

  useEffect(() => {
    if (pageContent?.billing) {
      setBillingContent(pageContent.billing);
    }

    if (pageContent?.generic) {
      setGenericContent(pageContent.generic);
    }

    // const targetCaseUrl = process.env.REACT_APP_API_CASE_INFO_ENDPOINT;
    // getApiService(baseUrl, targetCaseUrl, { cim: Payload?.cim }, headers)
    //   .then((response) => {
    //     if (response?.data?.statusCode !== 200) {
    //       setCaseInfoErrorFlag(true);
    //     } else {
    //       const result = response.data.data;
    //       setCaseInfoErrorFlag(false);
    //       setCaseInfo(result);
    //     }
    //   })
    //   .catch(error => {
    //     setCaseInfoErrorFlag(true);
    //   });

    // Set address and email from caseInfo if available
    if (caseInfo && caseInfo?.mailAddress) {
      setAddress(caseInfo?.mailAddress);
    }
    if (caseInfo && caseInfo?.email) {
      setEmail(caseInfo?.email);
    }
  }, [pageContent]);

    //Open Billing History Modal if viewBillHistory flag is set in Cookies
    useEffect(() => {
      const viewBillHistoryFlag = Cookies.get("viewBillHistory");
      if (viewBillHistoryFlag === "true") {
        handleModal("billingHistory");    
        Cookies.remove("viewBillHistory", getCookieOptions());
      }
    }, []);
  
  const handleCloseSchedulePaymentModal = () => {
    setShowSchedulePaymentModal(false);
  }

  const handleModal = (text) => {
    
    setModalText(text);

    if (Cookies.get("owningCarrier") !== "C4") {
      setShowSchedulePaymentModal(true);
    }
    
    // For Fiserv Carrier Molina, directly call the Fiserv login API and redirect to Fiserv portal
    if ((text === "schedulePayment" || text === "autopay") && Cookies.get("owningCarrier") === "C4") {
      handleFiservLogin();
      return;
    }
    
    // Fetch API Data based on modal type
    fetchApiData(text);

  };

  function handleDataFromAutopay(modalText) {
    sendDataToBilling(modalText);
  }

  function handleDataFromPreference(modalText) {
    sendDataToBilling(modalText);
  }

  //Call Api Service;
  const fetchApiData = (type) => {

    if (type === "billingPreference") {
      const targetGetActiveAccountsUrl =
        process.env.REACT_APP_API_GET_ACTIVE_ACCOUNTS_ENDPOINT;
      getApiService(
        baseUrl,
        targetGetActiveAccountsUrl,
        { cim: Payload?.cim, request: "1" },
        headers
      )
        .then((response) => {
          setActiveLoading(false);
          if (response?.data?.statusCode !== 200) {
            setBillingPrefErrorFlag(true);
          } else {
            setBillingPrefErrorFlag(false);
            const result = response.data.data;
            setActiveAccounts(result);
          }
        })
        .catch((error) => {
          setActiveLoading(false);
          setBillingPrefErrorFlag(true);
        });

      const targetBillingPreferenceUrl =
        process.env.REACT_APP_API_GET_BILL_PREFERENCE_ENDPOINT;
      getApiService(
        baseUrl,
        targetBillingPreferenceUrl,
        { cim: Payload?.cim },
        headers
      )
        .then((response) => {
          if (response?.data && response?.data?.status === "SUCCESS") {
            const result = response.data.data;
            setBillingPreference(result);
            setPrefLoading(false);
            if (
              result?.CurrentBillType === "WEBPORTAL" &&
              (result?.CurrentBillPref === "P6" ||
                result?.CurrentBillPref === "P7")
            ) {
              setCurrentBilling("AutomatedBilling");
            } else if (
              result?.CurrentBillPref === "P5" &&
              result?.CurrentBillType === "WEBPORTAL"
            ) {
              setCurrentBilling("Ebill");
            } else {
              setCurrentBilling("Paper");
            }
          }
        })
        .catch((error) => {
          console.error("Error fetching billing preference data:", error);
        });

      // No need to call case info API again as it's already set mailing and email from caseInfo props.
      // const targetCaseInfoUrl = process.env.REACT_APP_API_CASE_INFO_ENDPOINT;
      // getApiService(baseUrl, targetCaseInfoUrl, { cim: Payload?.cim, apiSource: 'settings' }, headers)
      //   .then((response) => {
      //     if (response?.data && response?.data?.status === 'SUCCESS') {
      //       const result = response.data.data;
      //       if (result) {
      //         setAddress(result?.mailAddress);
      //         setEmail(result?.email);
      //       }
      //     }
      //   })
      //   .catch(error => {
      //     console.error('Error fetching case data:', error);
      //   });
    }
  };

  return (
    <>
      <div className="col-lg-4 col-md-4 col-sm-4 px-2 mb-xl-0 mb-md-0 mb-sm-0 mb-3">
        <button
          type="button"
          className="card1 white-bg border-0 w-100 text-start"
          data-bs-toggle="modal"
          data-bs-target="#exampleModalFullscreen"
          onClick={() => handleModal(description)}
          aria-label={`${heading} - ${subHeading}`}
        >
          <div className="d-flex card-content-wrapper">
            <img
              src={image}
              width="60"
              height="60"
              className="me-3 card-icon"
              alt={`${heading} icon`}
            />
            <h2 className="fw-semibold mt-3 card-heading">
              {heading}
              <span className="mt-2 fw-normal d-block card-subheading">{subHeading}</span>
            </h2>
          </div>
        </button>
      </div>
      
      <Modal  size="xl" show={modalText === "billingHistory" && true} onHide={() => {setModalText();}}>
        <Billinghistory billingContent={billingContent} genericContent={genericContent} />
      </Modal>

      <Modal
        size={Payload?.owning_carrier === "Q5" ? undefined : "xl"}
        show={modalText === "billingPreference" && true}
        onHide={() => {
          setModalText();
        }}
      >
        <BillingPreference caseInfo={caseInfo} setModalText={setModalText} sendDataToCard={handleDataFromPreference} />
      </Modal>

      <Modal size="xl" show={modalText === "paymentHistory" && true} onHide={() => {setModalText(null);}}>
        <PaymentHistory billingContent={billingContent} genericContent={genericContent}/>
      </Modal>

      {showSchedulePaymentModal && (
        <Modal size="xl" show={modalText === "schedulePayment" && true} onHide={handleCloseSchedulePaymentModal}>
          <Schedulepayment handleCloseSchedulePaymentModal={handleCloseSchedulePaymentModal} />
        </Modal>
      )}
      
      <Modal size="xl" show={modalText === "paymentAuth" && true} onHide={() => {setModalText();}}>
        <Paymentauth billingContent={billingContent} genericContent={genericContent} />
      </Modal>

      <Modal size="md" show={modalText === "autopay" && Cookies.get("owningCarrier") !== "C4"} onHide={() => {setModalText(null);}}>
        <AutoPayModal 
          setModalText={setModalText} 
          sendDataToCard={handleDataFromAutopay} 
          billingContent={billingContent} 
          genericContent={genericContent} 
          />
      </Modal>
    </>
  );
};

export default Card;
